// src/hooks/useAuth.ts
import { useSelector } from "react-redux";
import { RootState } from "../stores";

export const useAuth = () => {
  return useSelector((state: RootState) => state?.auth?.user);
};